import React, { useState } from "react";
import { Eye, Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

export const ImpersonationBanner = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonated_by) return null;

  const exit = async () => {
    setBusy(true);
    try {
      await api.post("/impersonation/exit");
      toast.success("Impersonation ended — you're back on your admin account");
      window.location.href = "/dashboard/admin/support";
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't exit impersonation");
      setBusy(false);
    }
  };

  return (
    <div className="sticky top-0 z-40 flex items-center gap-3 bg-rose-600 px-4 py-2 text-white" data-testid="impersonation-banner">
      <Eye className="h-4 w-4 shrink-0" />
      <div className="text-xs font-medium flex-1">
        Viewing as <strong>{user.name || user.email}</strong> ({user.email}) — every action is audit-logged. Session auto-expires in 30 minutes.
      </div>
      <button type="button" onClick={exit} disabled={busy} data-testid="impersonation-exit-btn"
        className="inline-flex items-center gap-1.5 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1 text-xs font-semibold transition disabled:opacity-60">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <LogOut className="h-3 w-3" />} Exit impersonation
      </button>
    </div>
  );
};
